<!-- Show dashboard layout only when authenticated and not on login page -->
<div class="dashboard-layout" *ngIf="shouldShowSidebar">
  <app-sidebar (changePasswordRequested)="openChangePasswordModal()"></app-sidebar>
  <div class="dashboard-content">
    <router-outlet />
  </div>
</div>

<!-- Show router outlet without layout for login page or when not authenticated -->
<div *ngIf="!shouldShowSidebar">
  <router-outlet />
</div>

<app-change-password-modal
  *ngIf="showChangePasswordModal"
  (close)="closeChangePasswordModal()">
</app-change-password-modal>

<app-session-expired-overlay
  *ngIf="sessionExpired$ | async">
</app-session-expired-overlay>

<div class="app-toast-stack" *ngIf="notificationService.messages$ | async as messages">
  <div
    *ngFor="let message of messages"
    class="app-toast"
    [ngClass]="'app-toast--' + message.type"
    role="status"
    aria-live="polite">
    <div class="app-toast__content">
      <span class="app-toast__message">{{ message.message }}</span>
      @if (message.action) {
        <button
          type="button"
          class="app-toast__action"
          (click)="message.action.fn()">
          {{ message.action.label }}
        </button>
      }
      <button
        type="button"
        class="app-toast__dismiss"
        aria-label="Dismiss notification"
        (click)="notificationService.dismiss(message.id)">
        ×
      </button>
    </div>
  </div>
</div>
